webpackJsonp([144342403179678],{

/***/ 414:
/***/ (function(module, exports) {

	module.exports = {"data":{"markdownRemark":{"html":"<hr>\n<p>Hi! My name's Bradley, and this is my blog. I'll put a bit of an overview of what I'll be doing here in this first post.</p>\n<p>I'll be using this blog to post about some of the things I love - namely, board games, Magic: The Gathering, anime, and sci-fi/fantasy literature and tv/movies.</p>\n<p>Some posts will end up being reviews of books/shows/movies/games/cards I really enjoyed, while others will be a more general description of something really interesting that I discovered or accomplished.</p>\n<p>I'm also currently working on my first novel, and once I start getting closer to publication (hopefully soon), I'll be posting more about that journey.</p>\n<p>As with most blogs, you can use the tags to look for related content.</p>\n<p>Thanks so much for visiting, and welcome to A Nerd's Word.</p>","frontmatter":{"date":"June 24, 2018","path":"/hello-world","title":"Hello, World!","tags":["Intro","Personal","Life","Writing"]}}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---hello-world-0cee7de95e553e52b25a.js